export const ALLOWED_IMAGE_EXTENSIONS = [
  'image/gif',
  'image/png',
  'image/jpeg',
];
